export default __webpack_public_path__ + "static/media/making_pay_request.ef7b18f0.png";